import type { ReactNode } from 'react'
import styles from './MutatorForm.module.css'

export interface MutatorFormProps {
  children?: ReactNode
}

/**
 * Stacks a mutator's fields.
 */
export function MutatorForm({ children }: MutatorFormProps) {
  return <div className={styles.root}>{children}</div>
}
